<div class="error-page">
  <h1 class="error-title">No batch found</h1>
  <p class="error-text">No batch currently found. Please try again.</p>
  <button class="ss-btn ss-btn-primary" (click)="retry()">Retry</button>
</div>
